import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CustomersPage from "@/pages/CustomersPage";
import MenuPage from "@/pages/MenuPage";
import OrdersPage from "@/pages/OrdersPage";
import Layout from "@/components/Layout";
import FatPage from "./pages/FatPage";
import SettingsPage from "@/pages/SettingsPage";

// Lazy load — Sentry SDK só carrega quando o cliente acessa /cardapio
const CardapioPage = lazy(() => import("@/pages/CardapioPage"));

function ProtectedLayout() {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (!token) return <Navigate to="/" replace />;
  return <Layout><Outlet /></Layout>;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route element={<ProtectedLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/faturamento" element={<FatPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="/cardapio" element={
          <Suspense fallback={<div className="min-h-screen bg-background" />}>
            <CardapioPage />
          </Suspense>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
